import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "impersonation-banner" }

import { ref } from 'vue'
import { useAxios } from '@/api/axios'
import { user } from '@/global/states/GlobalState'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpersonationBanner',
  setup(__props) {

const axios = useAxios()
const isStopping = ref(false)

function stopImpersonating () {
  isStopping.value = true

  axios.post('/api/stop-impersonating')
    .then(() => {
      window.location.href = '/platform-admin/dashboard'
    })
    .finally(() => isStopping.value = false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createTextVNode("Você está navegando como "),
      _createElementVNode("strong", null, _toDisplayString(_unref(user).name) + " " + _toDisplayString(_unref(user).last_name), 1),
      _createTextVNode(" (" + _toDisplayString(_unref(user).email) + ")", 1)
    ]),
    (!isStopping.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: stopImpersonating
        }, "Voltar para o admin"))
      : (_openBlock(), _createBlock(SpinnerLoaderButton, {
          key: 1,
          height: 32,
          maxWidth: 180
        }))
  ]))
}
}

})